import { Game, GamePlayer } from "../model/Game";
import { Season } from "../model/Season";

import * as firestoreClient from '../script/firestore-client'

const table = 'game'

export function save(
  id: string,
  season: Season,
  format: 'BO1' | 'BO3',
  host: GamePlayer,
  guest: GamePlayer,
) {
  const game: Game = {
    id: id,
    season: season,
    format: format,
    host: host,
    guest: guest,
    player_uuids: [host.uuid, guest.uuid],
    start_time: new Date().getTime()
  }
  firestoreClient.save(table, game, [id])
}

export async function update(game: Game) {
  firestoreClient.update(table, [game.id], game)
}

export async function findFromCache(id: string) {
  return await firestoreClient.findFromCache(table, [id]) as Game
}

export async function listFromCache(
  filterOps?: firestoreClient.FilterOption[],
  sortOps?: firestoreClient.SortOption[],
  limit?: number
): Promise<Game[]> {
  return await firestoreClient.listFromCache(table, filterOps, sortOps, limit) as Game[]
}

export async function listFromServer(
  filterOps?: firestoreClient.FilterOption[],
  sortOps?: firestoreClient.SortOption[],
  limit?: number
): Promise<Game[]> {
  return await firestoreClient.listFromServer(table, filterOps, sortOps, limit) as Game[]
}

export function watch(id: string, cb: (game: Game) => void) {
  return firestoreClient.watch(table, [id], data => {
    cb(data as Game)
  })
}